var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrapper"},[_vm._v(" Logging you out... "),_c('div',{staticClass:"loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }